<app-si-dialog header="Confirm to Deauthorize InboxIntel" modalFooterClasses="si-dialog__footer--centered">
    <ng-template appDialogBody>
        <div class="px-16 py-8">
            <div class="flex items-start gap-5">
                <fa-icon class="text-danger shrink-0 mt-0.5" [icon]="['fal', 'circle-exclamation']" size="2x"></fa-icon>
                <div>
                    <h5 class="m-0">Are you sure you want to deauthorize and stop using InboxIntel for your email account?</h5>
                    <h5 class="mt-2 mb-0">Email: <strong class="break-words">{{email}}</strong></h5>
                </div>
            </div>
        </div>
    </ng-template>

    <ng-template appDialogFooter>
        <button matButton="outlined" type="button" (click)="closeModal(false)">
            Cancel
        </button>
        <button matButton="filled" class="mat-error" type="submit" (click)="closeModal(true)">
            Yes, deauthorize
        </button>
    </ng-template>
</app-si-dialog>
